import type { MRT_ColumnDef } from "mantine-react-table-open";
import { DateInput } from "../../../../../../mantine/dates/DateInput/DateInput";
import { backendDateOrDateTimeToLuxonDateTimeOrNull } from "../../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTimeOrNull";
import { luxonDateTimeToBackendDateOrDateTime } from "../../../../../../utils/dates/luxonDateTimeToBackendDateOrDateTime";
import type { FictionalEnergyValueResponse } from "../../FictionalEnergyValueManager/FictionalEnergyValueManager";
import { updateRowData } from "./updateRowData";

function getLastDateColumn(
  creationError: string | null,
  editingError: string | null
): MRT_ColumnDef<FictionalEnergyValueResponse> {
  return {
    accessorKey: "lastDate",
    header: "Enddatum",
    size: 120,
    Edit: ({ table, row, cell }) => {
      const savedValue =
        cell.getValue() as FictionalEnergyValueResponse["lastDate"];
      const endDate =
        backendDateOrDateTimeToLuxonDateTimeOrNull(savedValue) ?? undefined;
      return (
        <DateInput
          defaultValue={endDate}
          error={
            table.getState().creatingRow?.id === row.id
              ? creationError
              : editingError
          }
          placeholder="Enddatum"
          onChange={(value) =>
            updateRowData({
              table,
              row,
              columnIds: ["lastDate"],
              newValues: [
                value ? luxonDateTimeToBackendDateOrDateTime(value) : null
              ]
            })
          }
        />
      );
    }
  };
}

export { getLastDateColumn };
